export const PRODUCT_DESCRIPTION_TWO_LINES_HEIGHT = 60
